import { render } from "./DestroySickLeaveComponent.vue?vue&type=template&id=7990dc70"
import script from "./DestroySickLeaveComponent.vue?vue&type=script&lang=js"
export * from "./DestroySickLeaveComponent.vue?vue&type=script&lang=js"

import exportComponent from "/Users/jellevanoosterbosch/PhpstormProjects/haaer/haaer-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__